module.exports = __webpack_public_path__ + "img/whatsapp_with_beak.beb8562b.svg";